import React, { useCallback } from 'react';
import { FieldValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import DocumentTitle from '../../utilComponents/DocumentTitle';
import ResourceFormView from '../../apiForm/scaffold/ResourceFormView';
import useTransactionConfigApi from '../../project/useTransactionConfigApi';
import TransactionsForm from './TransactionsForm';

export default function TransactionsView() {
  const api = useTransactionConfigApi();

  const fetch = useCallback(async () => {
    const config = await api.getTransactionConfig(null);
    return config;
  }, [api]);

  const onSubmit = useCallback(
    async (data: FieldValue<any>) => {
      await api.updateTransactionConfig(data);
    },
    [api],
  );

  const { t } = useTranslation();

  return (
    <>
      <DocumentTitle translationID="transactionConfig.transactions.headline" />
      <div>
        <ResourceFormView
          actionName="transactions"
          Form={TransactionsForm}
          fetch={fetch}
          submit={onSubmit}
          headline={t('headlines.transactions')}
        />
      </div>
    </>
  );
}
